import { Pipe, PipeTransform } from '@angular/core';
import { Document } from '../../../services/legal-doc.service';

@Pipe({
    name: 'legalDocumentsFilter',
    pure: false,
})
export class LegalDocumentsFilterPipe implements PipeTransform {
    transform(documents: Document[], onlyReading?: boolean): any {
        if (!documents) {
            return documents;
        }
        return documents.filter((document) => document.onlyReading === (onlyReading || false));
    }
}
